<!--
@Time : 2020/11/26 1:41 下午
@Author : yekong
@File : paiming.vue
@Software : PhpStorm
-->
<template>
  <div>
    <div class="paiming">
      成本控制
    </div>
    <div class="paiming2">
      <p class="biaoti">
        本市成本控制平均得分为88分,与第一名上海少8分,在对标城市中排名第2。在对标城市中排名第2。
      </p>
      <div class="paimingk">
        <div class="paiming3">
          <div class="head">
            <div class="item1">成本明细</div>
            <div class="item2">北京</div>
            <div class="item2">上海</div>
            <div class="item2">深圳</div>
            <div class="item2">大连</div>
          </div>
          <div class="body">
            <div class="bodyitem" v-for="(item,index) in list" :key="index">
              <div class="item1">{{ item.title }}</div>
              <div class="item2">{{ item.number1 }}</div>
              <div class="item2">{{ item.number2 }}</div>
              <div class="item2">{{ item.number3 }}</div>
              <div class="item2">{{ item.number4 }}</div>
            </div>
          </div>
        </div>
        <div class="paiming4">
          <chengben :list="list2"></chengben>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chengben from "@/components/chengben";

export default {
  name: "paiming",
  components: {chengben},
  data: function () {
    return {
      list2: [{
        title: '上海',
        fenshu: 90,
        danwei: '分',
      }, {
        title: '大连',
        fenshu: 80,
        danwei: '分',
      }, {
        title: '北京',
        fenshu: 80,
        danwei: '分',
      }, {
        title: '深圳',
        fenshu: 80,
        danwei: '分',
      }],
      list: [{
        title: '用电报装申请',
        number1: 560,
        number2: 120,
        number3: 111,
        number4: 214,
      }, {
        title: '供电方案答复 ',
        number1: 560,
        number2: 236,
        number3: 213,
        number4: 142,
      }, {
        title: '办理道路挖掘许可',
        number1: 560,
        number2: 125,
        number3: 331,
        number4: 342,
      }, {
        title: '完成工程施工',
        number1: 560,
        number2: 232,
        number3: 234,
        number4: 123,
      }, {
        title: '竣工检验',
        number1: 560,
        number2: 240,
        number3: 154,
        number4: 324,
      }, {
        title: '装表接电',
        number1: 560,
        number2: 125,
        number3: 331,
        number4: 342,
      }, {
        title: '高压用电平均价格',
        number1: 560,
        number2: 232,
        number3: 234,
        number4: 123,
      }, {
        title: '低压用电平均价格',
        number1: 560,
        number2: 240,
        number3: 154,
        number4: 324,
      },]
    }
  },
  props: {
    top: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  filters: {},
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById('myChart'))
      // 绘制图表
      myChart.setOption({
        grid: {
          top: '5%',
          right: '10%',
          left: '10%',
          bottom: '12%'
        },
        xAxis: [{
          type: 'category',
          color: '#59588D',
          data: ['北京', '上海', '深圳', '大连'],
          axisLabel: {
            margin: 20,
            color: 'rgba(236, 239, 249, 1)',
            textStyle: {
              fontSize: 18
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(107,107,107,0.37)',
            }
          },
          axisTick: {
            show: false
          },
        }],
        yAxis: [{
          axisLabel: {
            formatter: '{value}分',
            color: 'rgba(159, 177, 255, 1)',
            textStyle: {
              fontSize: 22
            },
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(107,107,107,0.37)',
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(131,101,101,0.2)',
              type: 'dashed',
            }
          }
        }],
        series: [{
          type: 'bar',
          data: [90, 80, 20, 20],
          barWidth: '33px',
          itemStyle: {
            normal: {
              color: function (params) {
                var colorList = ['rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(63, 190, 226, 1)', 'rgba(236, 141, 91, 1)'];
                return colorList[params.dataIndex];
              },
              barBorderRadius: [15, 15, 0, 0]
            },
          },
          label: {
            normal: {
              show: false,
              fontSize: 18,
              fontWeight: 'bold',
              color: '#333',
              position: 'top',
            }
          }
        }
        ]
      });
    }
  },
  mounted() {
    this.drawLine();

  },
}
</script>

<style lang="scss" scoped>
@import "../../main";

.paiming {
  height: 145px;
  @include flex_start_center();
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;

}

.paiming2 {
  width: 1209px;
  height: 732px;
  background: url("../../assets/kuangjialeft.png") left top no-repeat,
  url("../../assets/kuangjiabottom.png") right bottom no-repeat,
  rgba(35, 77, 205, 0.16);
  padding-top: 40px;

  .head {
    width: 725px;
    height: 77px;
    margin: auto;
    background: rgba(199, 203, 214, 1);
    @include flex_between_center();

    .item1, .item2, .item3 {
      width: 15%;
      @include flex_center_center();
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #0C1638;
    }

    .item1 {
      width: 40%;
      @include flex_start_center();
      text-indent: 30px;
    }
  }
}

.body {
  width: 725px;
  margin: auto;
}

.bodyitem {
  height: 60px;
  @include flex_between_center();
  border-bottom: 2px solid rgba(77, 90, 127, 1);
  box-sizing: border-box;

  .item1, .item2, .item3 {
    width: 15%;
    @include flex_center_center();
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #ECEFF9;
  }

  .item1 {
    width: 40%;
    @include flex_start_center();
    text-indent: 30px;
  }
}

.biaoti {
  width: 1237px;
  height: 57px;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ECEFF9;
  line-height: 36px;
  margin-left: 23px;
}

.paimingk {
  @include flex_start_start();
  margin-left: 23px;
  margin-top: 30px;
}

.paiming4 {
  height: 477px;
  @include flex_center_center();
}
</style>
